import { hyperdbHandlers } from 'hyperdb-utils';

const handlers = hyperdbHandlers({ namespace: 'DASHBOARD' });
export default {
  ...handlers,
  __INIT() {
    return {
      loading: false,
      error: null,
    };
  },
  DASHBOARD__GET_MENU_DATA(state) {
    return { ...state, menu_loading: true, menu_error: null };
  },
  DASHBOARD__GET_MENU_DATA_SUCCESSFULL(state, { payload }) {
    const data = payload;
    return { ...state, ...data, menu_loading: false, menu_error: null };
  },
  DASHBOARD__GET_MENU_DATA_FAILED(state, { payload }) {
    const menu_error = payload;
    return { ...state, menu_loading: false, menu_error };
  },
  DASHBOARD__GET_OVERVIEW_DATA(state) {
    return { ...state, overview_loading: true, overview_error: null };
  },
  DASHBOARD__GET_OVERVIEW_DATA_SUCCESSFULL(state, { payload }) {
    const data = payload;
    return { ...state, ...data, overview_loading: false, overview_error: null };
  },
  DASHBOARD__GET_OVERVIEW_DATA_FAILED(state, { payload }) {
    const overview_error = payload;
    return { ...state, overview_loading: false, overview_error };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/dashboard/handlers.js